export enum UserBalanceDetailTypes {
    Truck = 1,
    ExtraBill = 2,
    Transaction = 3,
}
